import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import {
  IonCol,
  IonGrid,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonList,
  IonRow,
  IonSpinner,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { UUID } from '@okcargo-apps/shared-domain';
import { DateFnsModule } from 'ngx-date-fns';
import { AccountService } from '../../account';
import { BatchImportStoreService } from '../batch-import-store.service';

@Component({
  selector: 'lib-batch-import-errors',
  templateUrl: './batch-import-errors.component.html',
  styleUrls: ['./batch-import-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IonItemDivider,
    IonItemGroup,
    IonList,
    IonSpinner,
    IonGrid,
    IonRow,
    IonLabel,
    IonItem,
    IonCol,
    DateFnsModule,
    TranslateModule,
  ],
})
export class BatchImportErrorsComponent {
  public readonly id = input.required<UUID>();

  private readonly batchImportStoreService = inject(BatchImportStoreService);
  private readonly accountService = inject(AccountService);

  protected readonly currentBatchImportVM = this.batchImportStoreService.currentBatchImportVM;

  protected readonly batchImportRows = computed(() => this.currentBatchImportVM().item);
  protected readonly isLoading = computed(() => this.currentBatchImportVM().isLoading);
  protected readonly hasError = computed(() => this.currentBatchImportVM().error);

  protected readonly userCompanyId = computed(() => this.accountService.account().company.id);

  constructor() {
    effect(() => {
      const inputId = this.id();
      //const currentId = this.batchImportRows()?.id;
      //if (inputId !== currentId) {
      this.batchImportStoreService.setSelectedBatchImportId(inputId);
      //}
    });
  }
}
